import { HTTPMethodType } from '../../components/data-grid/data-grid-utils';
import theme from '../../theme';
export const groupColDefs = [
    {
        headerName: 'Name',
        field: 'groupName',
        sortable: true,
        cellStyle: {
            color: theme.colors.accent[200]
        }
    },
    {
        headerName: 'Type',
        field: 'groupType',
        sortable: true
    }
];
const groupDetailFields = [
    {
        label: 'Name',
        key: 'groupName',
        required: true,
        type: 'text',
        readonly: false
    },
    {
        label: 'Type',
        key: 'groupType',
        required: true,
        type: 'text',
        readonly: false
    }
];
const cellFieldGroup = {
    label: 'Cells',
    fields: groupDetailFields
};
export const groupDetailForm = {
    fieldGroups: [
        cellFieldGroup
    ],
    buttons: [
        {
            buttonType: 'submit',
            buttonText: 'Back'
        }
    ]
};
export const getEndpointDataByTenantId = (tenantId)=>{
    const params = [
        [
            'tenantId',
            `${tenantId}`
        ]
    ];
    const endPoint = {
        endPoint: '/users/groups/tenant/v1',
        HTTPMethodType: HTTPMethodType.GET,
        params: params
    };
    return endPoint;
};
export const gridOptions = {
    suppressHorizontalScroll: true,
    paginationPageSizeSelector: false
};
export var eligibleGroupTypeRoleIds = /*#__PURE__*/ function(eligibleGroupTypeRoleIds) {
    eligibleGroupTypeRoleIds["CODING_MANAGER"] = "coding_manager";
    eligibleGroupTypeRoleIds["CODER"] = "coder";
    eligibleGroupTypeRoleIds["CQA_CODER"] = "cqa_coder";
    eligibleGroupTypeRoleIds["CQA_MANAGER"] = "cqa_manager";
    return eligibleGroupTypeRoleIds;
}({});
export var groupTypeIds = /*#__PURE__*/ function(groupTypeIds) {
    groupTypeIds["CODING_GROUP"] = "CODING_GROUP";
    groupTypeIds["CQA_GROUP"] = "CQA_GROUP";
    return groupTypeIds;
}({});
export const groupTypes = [
    {
        label: 'Coding group',
        value: "CODING_GROUP"
    },
    {
        label: 'CQA group',
        value: "CQA_GROUP"
    }
];
